import { render, staticRenderFns } from "./BetaChip.vue?vue&type=template&id=06b3d4a9&"
import script from "./BetaChip.vue?vue&type=script&lang=js&"
export * from "./BetaChip.vue?vue&type=script&lang=js&"
import style0 from "./BetaChip.vue?vue&type=style&index=0&id=06b3d4a9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports